// extracted by mini-css-extract-plugin
module.exports = {"footer":"_93444fe79c--footer--R7SMa","link":"_93444fe79c--link--gFHa1"};